/**
 * Types
 */

export const Types = {
  SET_SELECTED_PLAN: "plan/SET_SELECTED_PLAN",
  UPDATE_INSTALLMENTS_SELECTED_PLAN: "plan/UPDATE_INSTALLMENTS_SELECTED_PLAN",
}
